// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class TempGetNumberOfApplicationsDefaultResponse {
    static getAttributeTypeMap() {
        return TempGetNumberOfApplicationsDefaultResponse.attributeTypeMap;
    }
}
TempGetNumberOfApplicationsDefaultResponse.discriminator = undefined;
TempGetNumberOfApplicationsDefaultResponse.additionalProperties = false;
TempGetNumberOfApplicationsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "TempGetNumberOfApplicationsDefaultResponseData"
    },
];
//# sourceMappingURL=tempGetNumberOfApplicationsDefaultResponse.js.map